import { CustomerContent } from "../../components/accounting";

export default function Customer() {
  return <CustomerContent />;
}
